const loserItems = [
  "Comprar un PDF de 100 Prompts genéricos",
  "Guardarlo en el celular y olvidarlo",
  "No saber cómo usarlo en tu negocio",
  "Seguir sin vender. Mes tras mes.",
];

const winnerItems = [
  "Entrar a tu software privado en segundos",
  "Presionar un botón y generar promos",
  "Copiar scripts ganadores listos para usar",
  "Cerrar ventas todos los días sin estrés",
];

export default function ProblemSolution() {
  return (
    <section className="relative bg-[#0B0F19] py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-[#0B0F19] via-[#0d1120] to-[#0B0F19]" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8">
        {/* Section header */}
        <div className="text-center mb-14">
          <p className="text-[#a78bfa] text-sm font-semibold uppercase tracking-widest mb-3">
            La Diferencia es Brutal
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white leading-tight">
            ¿Cuál camino{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#a78bfa] to-[#7C3AED]">
              eliges tú?
            </span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {/* Loser column */}
          <div className="relative group">
            <div className="absolute inset-0 bg-red-500/5 rounded-2xl blur-xl group-hover:bg-red-500/10 transition-all duration-500" />
            <div className="relative bg-white/5 backdrop-blur-sm border border-red-500/30 rounded-2xl p-6 md:p-8 h-full">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 flex items-center justify-center bg-red-500/20 rounded-full border border-red-500/40">
                  <i className="ri-close-circle-fill text-red-400 text-xl"></i>
                </div>
                <div>
                  <p className="text-red-400 text-xs font-bold uppercase tracking-widest">
                    Lo que hace el 99%
                  </p>
                  <h3 className="text-white font-black text-lg">La Vía Perdedora</h3>
                </div>
              </div>

              <ul className="space-y-4">
                {loserItems.map((item, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-close-line text-red-400 text-lg"></i>
                    </div>
                    <span className="text-white/60 text-sm md:text-base leading-relaxed line-through decoration-red-500/50">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>

              <div className="mt-8 p-4 bg-red-500/10 border border-red-500/20 rounded-xl">
                <p className="text-red-300 text-sm font-semibold text-center">
                  😔 Resultado: Seguir sin vender. Siempre.
                </p>
              </div>
            </div>
          </div>

          {/* Winner column */}
          <div className="relative group">
            <div className="absolute inset-0 bg-emerald-500/10 rounded-2xl blur-xl group-hover:bg-emerald-500/15 transition-all duration-500" />
            <div className="relative bg-white/5 backdrop-blur-sm border border-emerald-500/40 rounded-2xl p-6 md:p-8 h-full">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 flex items-center justify-center bg-emerald-500/20 rounded-full border border-emerald-500/40">
                  <i className="ri-rocket-2-fill text-emerald-400 text-xl"></i>
                </div>
                <div>
                  <p className="text-emerald-400 text-xs font-bold uppercase tracking-widest">
                    Lo que harás tú
                  </p>
                  <h3 className="text-white font-black text-lg">La Vía NegoIA</h3>
                </div>
              </div>

              <ul className="space-y-4">
                {winnerItems.map((item, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-emerald-400 text-lg font-bold"></i>
                    </div>
                    <span className="text-white/85 text-sm md:text-base leading-relaxed font-medium">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>

              <div className="mt-8 p-4 bg-emerald-500/10 border border-emerald-500/20 rounded-xl">
                <p className="text-emerald-300 text-sm font-semibold text-center">
                  🚀 Resultado: Ventas todos los días. Sin excusas.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
